module.exports = __webpack_public_path__ + "img/RunningWays.93bdeef6.jpg";